import AbstractModule from './AbstractModule';
import {$window, $document, $body, APP_NAME} from '../utils/environment';

const DATA_KEY = `${APP_NAME}.Newsletter`;
const EVENT_KEY = `.${DATA_KEY}`;

const Event = {
    CLICK:  `click${EVENT_KEY}`,
    INPUT:  `input${EVENT_KEY}`,
    CHANGE: `change${EVENT_KEY}`,
    SUBMIT: `submit${EVENT_KEY}`
};

export default class extends AbstractModule {


    /**
     * Constructor.
     *
     * @return {void}
     */
    constructor(options) {
        super(options);

        this.isTransmitting = false;
        this.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
        this.processData = true;
        this.$form = this.$el.find('form');
        this.$preSubmit = this.$el.find('.js-pre-submit');
        this.$postSubmit = this.$el.find('.js-post-submit');
    }

    /**
     * Initialize dom and events.
     *
     * @return {void}
     */
    init() {
        this.$form.on(Event.SUBMIT, event => this.onPreSubmit(event));
    }

    onPreSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        this.submit();
    }

    /**
     * Submits the form data to an URL with $.ajax
     *
     * @return {void}
     */
    submit() {
        const data = this.$form.serializeArray();

        let xhrRequest;

        if (!this.isTransmitting) {
            this.toggleLoading();

            setTimeout(() => {
                xhrRequest = $.ajax({
                    method:      (this.$form.prop('method') || 'POST'),
                    url:         (this.$form.prop('action')),
                    contentType: this.contentType,
                    processData: this.processData,
                    data:        data,
                    dataType:    'json'
                })
                    .done((response, textStatus) => {
                        if (response.success === true) {
                            this.$preSubmit.fadeOut(() => {
                                this.$postSubmit.fadeIn(() => {
                                    $('.js-scroll').triggerHandler('update.LocomotiveScroll');
                                    $('.js-scroll').triggerHandler({
                                        type:    'scrollTo.LocomotiveScroll',
                                        options: {
                                            targetElem:   this.$postSubmit,
                                            targetOffset: -500
                                        }
                                    });
                                });
                            });

                        } else {
                            console.warn(`Something went wrong with the request (done, ${textStatus})`);
                        }
                    })
                    .fail((response, textStatus) => {
                        if (typeof response.responseJSON.errors !== 'undefined' && response.responseJSON.errors.length > 0) {
                            // this.manageErrors(response.responseJSON.errors);
                        } else {
                            console.group(`Something went wrong with the request (fail, ${textStatus})`);
                            console.log(response);
                            console.log(textStatus);
                            console.groupEnd();
                        }
                    })
                    .always(() => {
                        this.toggleLoading();
                    });
            }, 600);
        }
    }

    /**
     * Simple method for toggling animation states
     *
     * @return void
     */
    toggleLoading() {
        this.isTransmitting = !this.isTransmitting;
        this.$el.toggleClass('is-form-state-loading');
    }

    /**
     * Destructor.
     *
     * @return {void}
     */
    destroy() {
        $window.off(EVENT_KEY);
        $document.off(EVENT_KEY);
        this.$el.off(EVENT_KEY);
    }
}
